// extracted by mini-css-extract-plugin
export default {"container":"input_container__hfZjQ","input":"input_input__EBh3D","icon":"input_icon__qgGVQ","label":"input_label__j-IUX","new":"input_new__1CPVw","focused":"input_focused__S2vL2"};